import { Controller } from 'stimulus';


class Select extends Controller {

  initialize() {
    // console.log('select controller initialized');
  }
  getData(e) {
    this.dispatch("getData", { target: this.checkboxTarget, detail: { content: e } });
  }
  toggleOptions(e) {
    e.preventDefault();

    this.dispatch("toggleOptions", { target: this.buttonTarget, detail: { content: this.buttonTarget } })
    
    this.optionsTarget.classList.toggle('hidden');
    this.buttonTarget.classList.toggle('active');
    if (this.buttonTarget.classList.contains('active')) this.buttonTarget.setAttribute('aria-selected', 'true');
    else this.buttonTarget.setAttribute('aria-selected', 'false');
  
  }

  resetFilter(e) {
    this.dispatch("resetFilter", { target: this.resetTarget, detail: { content: e } })
  }
}

Select.targets = ['button', 'options', 'checkbox', 'reset'];

export default Select;